import {
    EmailVerifyResendModel,
    PasswordChangeRequest,
    UserDeleteModel,
    UserInfoModel,
    UserPasswordResetGetTokenModel,
} from '../swagger/dto'
import { getRequest, patchRequest, postRequest } from './config'
import {
    EMAIL_VERIFY_RESEND_CODE_URL,
    LOGIN_URL,
    PASSWORD_RESET_COMPLETE_URL,
    PASSWORD_RESET_GET_TOKEN_URL,
    PASSWORD_RESET_URL,
    REGISTRATION_URL,
    VERIFY_EMAIL_URL,
} from './endpoints.constants'

export const login = async (params) => {
    const response = await postRequest<unknown, void>(LOGIN_URL, params)
    return response.data
}

export const registration = async (data) => {
    const response = await postRequest<unknown, void>(REGISTRATION_URL, data)
    return response.data
}

export const verifyEmail = async (data) => {
    const response = await postRequest<unknown, void>(VERIFY_EMAIL_URL, data)
    return response.data
}

export const passwordReset = async (data) => {
    const response = await postRequest<unknown, void>(PASSWORD_RESET_URL, data)
    return response.data
}

export const passwordResetGetToken = async (data: UserPasswordResetGetTokenModel) => {
    const response = await postRequest<unknown, void>(PASSWORD_RESET_GET_TOKEN_URL, data)
    return response.data
}

export const passwordResetComplete = async (data) => {
    const response = await postRequest<unknown, void>(PASSWORD_RESET_COMPLETE_URL, data)
    return response.data
}

export const emailVerifyResendCode = async (data: EmailVerifyResendModel) => {
    const response = await postRequest<unknown, void>(EMAIL_VERIFY_RESEND_CODE_URL, data)
    return response.data
}

export const getUserData = async () => {
    const { data } = await getRequest<UserInfoModel>('user')

    return data
}

export const patchUserData = async (user: Partial<UserInfoModel>) => {
    const { data } = await patchRequest<Partial<UserInfoModel>>('user', user)

    return data
}

export const changeEmail = async (email: string) => {
    const response = await postRequest('auth/user_email_verify/start', email)
    return response.data
}

export const changePassword = async (params: PasswordChangeRequest) => {
    const response = await postRequest('auth/user_password_change', params)
    return response.data
}

export const deleteUser = async (data: UserDeleteModel) => {
    const response = await postRequest('user/delete', data)
    return response.data
}
